import { TableName } from './tableName.enum';

export const EventFeeFunctions = {
  [TableName.Club]: 'clubFees',
  [TableName.Team]: 'teamFees',
  [TableName.User]: 'userFees'
};
